"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MultiDict_instances, _MultiDict_map, _MultiDict_set;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiDict = void 0;
/**
 * A multi-key multi-value map implementation.
 *
 * - When a pair of KV is set, both keys and values are indexed as keys in the
 * map, allowing reverse lookups.
 *
 * - Values are always a Set.
 *
 * - Deleting a key deletes it from both directions.
 */
class MultiDict {
    constructor() {
        _MultiDict_instances.add(this);
        // This type doesn't work: `Map<K, Set<V>> | Map<V, Set<K>>`
        _MultiDict_map.set(this, new Map());
    }
    /** Delete all entries */
    clear() {
        __classPrivateFieldGet(this, _MultiDict_map, "f").clear();
    }
    delete(key, value) {
        if (value !== undefined) {
            let result = __classPrivateFieldGet(this, _MultiDict_map, "f").get(key)?.delete(value) ?? false;
            result &&= __classPrivateFieldGet(this, _MultiDict_map, "f").get(value)?.delete(key) ?? false;
            return result;
        }
        const values = __classPrivateFieldGet(this, _MultiDict_map, "f").get(key);
        let result = __classPrivateFieldGet(this, _MultiDict_map, "f").delete(key);
        if (values) {
            for (const value of values) {
                const revRef = __classPrivateFieldGet(this, _MultiDict_map, "f").get(value);
                if (revRef) {
                    result &&= revRef.delete(key) ?? false;
                    if (revRef.size === 0) {
                        __classPrivateFieldGet(this, _MultiDict_map, "f").delete(value);
                    }
                }
            }
            return result;
        }
        return result;
    }
    /**
     * Returns an iterable of key, value pairs for every entry in the map.
     *
     * Keys and values are interchangeable, expect all existing keys and values
     * being invoked as the "key" once.
     */
    entries() {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").entries();
    }
    /**
     * Calls a function for each key-value pair in the map.
     *
     * Keys and values are interchangeable, expect all existing keys and values
     * being invoked as the "key" once.
     */
    forEach(callbackfn, thisArg) {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").forEach(callbackfn, thisArg);
    }
    get(key) {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").get(key);
    }
    /**
     * Returns a boolean indicating whether an element with the specified key
     */
    has(key) {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").has(key);
    }
    /**
     * Keys and values are interchangable, this is an iterator for all keys and
     * values.
     */
    keys() {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").keys();
    }
    set(key, value) {
        var _a;
        return __classPrivateFieldGet((_a = __classPrivateFieldGet(this, _MultiDict_instances, "m", _MultiDict_set).call(this, key, value)), _MultiDict_instances, "m", _MultiDict_set).call(_a, value, key);
    }
    /**
     * Return the size of the map. Since keys and values are interchangeable, it
     * is the total number of unique keys and values.
     */
    get size() {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").size;
    }
    /**
     * Returns an iterable of values in the map.
     *
     * Keys and values are interchangeable, therefore values set as keys will be
     * returned as a single-value Set.
     */
    values() {
        return __classPrivateFieldGet(this, _MultiDict_map, "f").values();
    }
    [(_MultiDict_map = new WeakMap(), _MultiDict_instances = new WeakSet(), _MultiDict_set = function _MultiDict_set(key, value) {
        const set = __classPrivateFieldGet(this, _MultiDict_map, "f").get(key) ?? new Set();
        set.add(value);
        __classPrivateFieldGet(this, _MultiDict_map, "f").set(key, set);
        return this;
    }, Symbol.iterator)]() {
        return __classPrivateFieldGet(this, _MultiDict_map, "f")[Symbol.iterator]();
    }
    get [Symbol.toStringTag]() {
        return "MultiDict";
    }
}
exports.MultiDict = MultiDict;
